import { render, staticRenderFns } from "./Board.vue?vue&type=template&id=40ec07db&scoped=true&"
import script from "./Board.vue?vue&type=script&lang=js&"
export * from "./Board.vue?vue&type=script&lang=js&"
import style0 from "./Board.vue?vue&type=style&index=0&id=40ec07db&prod&lang=less&scoped=true&"
import style1 from "./Board.vue?vue&type=style&index=1&id=40ec07db&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ec07db",
  null
  
)

export default component.exports